import React from "react";
import key_7 from "../assets/111.png";
import Header from "./Header";
import icon_a from "../assets/check.png";
import additional from "../assets/additional.png";
import king1 from "../assets/Fruit-Juice-view/1.png";
import king2 from "../assets/Fruit-Juice-view/2.png";
import king3 from "../assets/Fruit-Juice-view/3.png";
import king4 from "../assets/Fruit-Juice-view/4.png";
import kingkong1 from "../assets/fruit-juice/4.png";
import kingkong2 from "../assets/fruit-juice/3.png";
import kingkong4 from "../assets/fruit-juice/2.png";

const FruitJucie = () => {
  const fruitJuiceImages = [
  {
    src: king1,
    alt: "Fruit Juice Slot Machine Reel Theme",
    title: "Fruit Juice Slot Machine Reel Theme"
  },
  {
    src: king2,
    alt: "Fruit Juice Slot Machine Buy Bonus Feature",
    title: "Fruit Juice Slot Machine Buy Bonus Feature"
  },
  {
    src: king3,
    alt: "Fruit Juice Slot Machine Winning Amount Feature",
    title: "Fruit Juice Slot Machine Winning Amount Feature"
  },
  {
    src: king4,
    alt: "Fruit Juice Slot Machine Mega Win Feature",
    title: "Fruit Juice Slot Machine Mega Win Feature"
  }
];
  const features = [
    {
      title: "Stunning Graphics",
      text: " Immerse yourself in a colorful fruit-themed world with vibrant visuals and smooth animations",
    },
    {
      title: "Engaging Game play",
      text: " With multiple features like multipliers, sticky wilds, and skill games, every spin is a new adventure."
    },
    {
      title: "Big Wins",
      text: "The Juice Meter and accumulative multipliers ensure that every win has the potential to be huge."
    },
    {
      title: "Progressive Jackpot",
      text: "Take a shot at winning the ultimate prize with the ever-growing progressive jackpot."
    },
  ];

  const gameList = [
    "Fruit Juice",
    "King of the Jungle",
    "Urban Fighter",
    "Fruit Juice",
    "Fruit Juice",
    "Fruit Juice",
    "Fruit Juice",
  ];

  return (
    <div>
      <Header />

      {/* Intro Section */}
      <section className="bg-white py-10 px-4 md:px-10 lg:px-16 xl:px-48 mx-auto">
        <h2 className="text-3xl md:text-4xl text-left font-extrabold py-2 poppins-font">
          Fruit Juice
        </h2>
        <hr className="w-14 bg-black h-[2px] border-none shadow-lg mb-7 hidden sm:block" />
        <p className="text-gray-500 font-medium text-lg poppins-font2 text-start leading-relaxed">
       Welcome to the vibrant world of Fruit Juice, a thrilling 5x3 reel slot game that combines the refreshing essence of fruits with exciting game play features. Packed with juicy rewards, sticky wilds, and multipliers, this fruit-themed slot is designed to keep you on the edge of your seat. Whether you're a casual player or a high roller, Fruit Juice offers something for everyone. Let’s dive into the details of this exhilarating game!
        </p>
      </section>

      {/* Main Game Features */}
      <section className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={kingkong1} alt="Fruit Juice Slot Main Game Features" title="Fruit Juice Slot Main Game Features" className="max-w-full h-auto" />
        </div>
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Main Game Features</h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            The base game is where the fun begins! Spin the reels and watch as the fruity symbols line up to create winning combinations. Here’s what makes the main game so exciting:
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700"> Accumulative Multipliers: </strong>Land a winning combination with the special symbol, and you will activate accumulative multipliers of 2x, 3x, or 5x. These multipliers stack up, giving you the chance to boost your winnings with every spin!
          </p>
        </div>
      </section>

      {/* Free Game Features */}
      <section className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col-reverse lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">
            Free Game Features: <span className="text-[#FF5300]">Fruit Juice</span>
          </h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            The Juice Meter is the heart of the Free Game feature, adding an extra layer of excitement to your game play. Located above the reels, the Juice Meter fills up with every win, contributing juicy drops that unlock incredible rewards. Here’s how it works:
          </p>
          <p className="text-gray-500 pb-4 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Level 1: </strong> Once the Juice Meter reaches Level 1, a Random Multiplier (2x to 5x) is activated and applied to your next win. Watch your winnings grow as the multiplier works its magic!
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Level 2: </strong> At Level 2, the wild symbols become Sticky Wilds! These wilds stick to the reels for the Free Game, increasing your chances of landing massive wins.
          </p>
        </div>
        <div className="lg:w-1/2 text-center">
          <img src={kingkong2} alt="Fruit Juice Slot Machine Reward Meter" title="Fruit Juice Slot Machine Reward Meter" className="max-w-full h-auto" />
        </div>
      </section>

      {/* Additional Features */}
      <section className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center"> 
          <img src={additional} alt="Grand Jackpot" title="Grand Jackpot" className="max-w-full h-auto" />
        </div>
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Additional Features</h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            Fruit Juice is packed with even more features to keep the excitement flowing:
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Nudge:</strong>  Get an extra nudge to align the reels perfectly for a winning combination.
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Skill Games:</strong>  Test your skills and unlock bonus rewards with interactive mini-games
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Pre-Reveal: </strong> Peek at what is coming next and strategist your spins for maximum wins.
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <strong className="text-gray-700">Link Jackpot: </strong> Connect with other players and compete for a shared jackpot prize
          </p>
         
        </div>
      </section>

      {/* Why Play Section */}
      <section className="bg-white py-20 px-4 md:px-10 lg:px-16 xl:px-48">
        <div className="flex flex-col lg:flex-row-reverse gap-16">
          <div className="lg:w-1/2 flex justify-center">
            <img src={kingkong4} alt="Fruit Juice Game And Features" title="Fruit Juice Game And Features" className="w-full max-w-md object-contain" />
          </div>
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black text-start">
              Why Choose Fruit Juice? 
            </h2>
            <div className="space-y-6">
              {features.map((item, idx) => (
                <div key={idx}>
                  <div className="flex items-center mb-2">
                    <img src={icon_a} alt="" className="w-6 h-6 mr-2" />
                    <h3 className="text-xl font-semibold text-black poppins-font">{item.title}:</h3>
                  </div>
                  <p className="text-gray-500 poppins-font2 text-start text-base leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="bg-gray-100 py-20">
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4 md:px-10 xl:px-48">
          {fruitJuiceImages.map((img, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-md">
              <img src={img.src} alt={img.alt} title={img.title} className="w-full rounded-md" />
            </div>
          ))}
        </div>
      </section>

      {/* Youtube Section */}
      <section className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48">
          <h2 className="text-start font-semibold text-2xl poppins-font">Games</h2>
          <hr className="w-14 bg-black h-[2px] border-none shadow-lg my-4 hidden sm:block" />
          <div className="aspect-video w-full">
            <iframe
              src="https://www.youtube.com/embed/YOUR_YOUTUBE_VIDEO_ID"
              title="King of Jungle Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Game List */}
      <section className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-8">
          {gameList.map((name, idx) => (
            <div key={idx} className="text-center">
              <img src={key_7} alt={`Game ${idx}`} className="w-36 h-36 mx-auto mb-4" />
              <p className="text-lg font-bold text-gray-500 poppins-font">{name}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FruitJucie;
